import React, { useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { useAuth } from '../context/AuthContext';
import { fetchProgramPdf, pdfErrorMessage, saveOnNative, saveOnWeb } from './programPdf';

// "Download PDF" on the program view. The logic is in programPdf.js; this is
// the button, its busy state, and its error.
//
// The native check is Capacitor.isNativePlatform(), not the presence of
// window.Capacitor: the web fallback of @capacitor/core defines that too, and a
// browser sent down the native branch would try to write to a filesystem it
// does not have.
const ProgramPdfButton = ({ programId }) => {
  const { token } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const download = async () => {
    setBusy(true);
    setError(null);
    try {
      const { blob, filename } = await fetchProgramPdf(programId, token);
      if (Capacitor.isNativePlatform()) {
        await saveOnNative(blob, filename);
      } else {
        saveOnWeb(blob, filename);
      }
    } catch (err) {
      setError(await pdfErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="program-pdf">
      <button
        type="button"
        className="btn-ghost program-pdf-btn"
        onClick={download}
        disabled={busy}
        aria-busy={busy}
      >
        {busy ? 'Preparing PDF…' : 'Download PDF'}
      </button>
      {error && (
        <p className="status-error program-pdf-error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default ProgramPdfButton;
